export default __webpack_public_path__ + "static/media/avatar-icon.e269bf34.svg";